export const STAMPA_ODR_POLL_INTERVAL_MS = 10000;

export function isStampaOdrPrintable(order = {}) {
    return Boolean(order.disegno)
        && String(order.schedulato) === "2"
        && Number(order.stampabile) === 2
        && !order.in_coda;
}

export function needsStampaOdrPolling(order = {}) {
    return !order.in_coda && Number(order.stampabile) !== 2;
}
